import { Injectable } from '@angular/core';
import { Globals } from './globals';
import { HttpClient } from '@angular/common/http';
import { SpreadsheetConversion, SpreadsheetConversionParams, SpreadsheetInfo } from 'app/models/spreadsheet-conversion';
import { UserService } from './user.service';
import { initiateDownload } from 'app/helpers/utils';

@Injectable({ providedIn: 'root' })
export class SpreadsheetConversionService {

    constructor(private http: HttpClient, private globals: Globals, private userService: UserService) {
    }

    public list() {
        return this.http.get<SpreadsheetConversion[]>(`${this.globals.api_base_url}/spreadsheet-conversion`, { params: {
        }});
    }

    public getSpreadsheetInfo(path: string, storage_id: number) {
        return this.http.get<SpreadsheetInfo>(`${this.globals.api_base_url}/spreadsheet-conversion/info`, { params: <any>{
            path: path,
            storage_id: storage_id
        }});
    }

    public convertToForm(conversionParams: SpreadsheetConversionParams) {
        return this.http.post<SpreadsheetConversion>(`${this.globals.api_base_url}/spreadsheet-conversion/import`, conversionParams);
    }

    public fillInForm(formTemplateId: number, conversionParams: SpreadsheetConversionParams) {
        return this.http.post<SpreadsheetConversion>(`${this.globals.api_base_url}/spreadsheet-conversion/form/${formTemplateId}`, conversionParams);
    }

    public undoConversionData(id: number) {
        return this.http.post<SpreadsheetConversion>(`${this.globals.api_base_url}/spreadsheet-conversion/${id}/undo`, {});
    }

    public downloadImportErrors(id: number) {
        initiateDownload(`${this.globals.api_base_url}/spreadsheet-conversion/${id}/download_import_errors?bearer=${this.userService.access_token}`);
    }
}